import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { QA_NAME_CONFIRMATION } from '../../../../constants/qa'
import { ConfirmationModal } from '../../../Confirmation'

import * as styles from './DocFlowEditSequenceModalConfirmation.module.css'

function DocFlowEditSequenceModalConfirmation({
  isCloseConfirm,
  onClose,
  onSetCloseConfirm,
}) {
  const { t } = useTranslation()

  function handleCancelCloseConfirm() {
    onSetCloseConfirm(false)
  }

  return (
    <ConfirmationModal
      actionButtonsProps={{
        cancelText: t('Modal.CommonGoBackBtnKey'),
        submitText: t('Modal.CloseBtnKey'),
      }}
      className={classNames(styles.modal, styles.confirmation, {
        [styles.visible]: isCloseConfirm,
      })}
      description={t('Modal.CancelConfirmationTitleKey')}
      qaName={QA_NAME_CONFIRMATION}
      onCancel={handleCancelCloseConfirm}
      onSubmit={onClose}
    />
  )
}

export default DocFlowEditSequenceModalConfirmation
